'use client';

import { PhoneAndMail } from '@/app/(components)/shared/PhoneAndMail';
import { mq } from '@/lib/StyledComponents/mq';
import { H2 } from '@/lib/StyledComponents/Typography';
import type { PhoneAndMailBlockData } from '@/schema/cms/blocks/PhoneAndMail.schema';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.875rem 0 0;

  ${mq('laptop')} {
    h2 {
      font-size: 2.25rem;
    }
  }
`;

export const ContactLinks = ({
  title,
  phoneAndMail,
}: {
  title: string;
  phoneAndMail: PhoneAndMailBlockData;
}) => {
  return (
    <Container>
      <H2>{title}</H2>
      <PhoneAndMail
        key={phoneAndMail.id}
        mail={phoneAndMail.mail}
        phoneNumber={phoneAndMail.phoneNumber}
      />
    </Container>
  );
};
